module.exports = __webpack_public_path__ + "fonts/founders-grotesk-bold.7d449b8.woff2";